import { Row, Col, Form } from "react-bootstrap";
import { useState } from "react";
import { TextInput, TextAreaInput, BrandSelectInput } from '../Misc/FormInput';
import ImageField from "./ImageField";
import { authFetch } from '../Auth/apiClient'
import { useMsal } from '@azure/msal-react';

const PromoProductForm = ({product, setProduct, handleProductsChange, promoDatabaseId, handleSaveNewProduct, handleEditProduct, promoId}) => {
    const { instance } = useMsal();
    const [autoFillFormState, setAutoFillFormState] = useState({});
    const [autoFillSearchFormState, setAutoFillSearchFormState] = useState({ sku: '', mfr: '' });
    const [autoFillLoading, setAutoFillLoading] = useState(false);
    const isNew = product.isNew;

    const searchForImage = (searchTerm, index) => {
        // This is where you'll implement your image search function
        console.log(`Searching for ${searchTerm} for image ${index}`);
        // For now, just a placeholder
        // When implemented, this should update product[`image${index}`] with the found image URL
      };

    
    const handleProductFormSubmit = (event) =>  {
        event.preventDefault();
        console.log(product);
        authFetch(instance, '/api/create_promo_product', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({"product": product, "promoDatabaseId": promoDatabaseId})
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);

            if (data.status !== 204) {
                throw new Error('Error saving product');
            }
        
            // If this is a new product being added
            if (product.isNew) {
                // Create a new product object with the returned ID and without the isNew flag
                const newProduct = {
                    ...product,
                    productId: data.productId
                };
                delete newProduct.isNew;
                
                // Call the parent function to add to products list
                handleSaveNewProduct(newProduct);
                alert('New product added successfully!');
            } else {
                // This is an existing product being updated
                handleEditProduct(product);
                alert('Product updated successfully!');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }
    //product = product.product;
    
    function dataFromAutoFill(key) {
        setProduct({...product, [key]: autoFillFormState[key]});
        let tempAutofillState = { ...autoFillFormState};
        delete tempAutofillState[key]
        if (key+'_name' in tempAutofillState) {
            delete tempAutofillState[key+'_name']
        }
        setAutoFillFormState(tempAutofillState);
    }

    function handleAutofillSearchInputChange(event) {
        const { target: { name, value } } = event;
        setAutoFillSearchFormState({
            ...autoFillSearchFormState,
            [name]: value,
        });
    }

    function queryPromoAutofill() {
        const sku = autoFillSearchFormState.sku.trim();
        const mfr = autoFillSearchFormState.mfr.trim();

        if (sku === '' && mfr === '') {
            alert('Please provide a SKU or MFR to search.');
            return;
        }

        setAutoFillLoading(true);
        authFetch(instance, '/api/autofill_promo_product', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ sku, mfr }),
        })
            .then(async (response) => {
                const contentType = response.headers.get('content-type') || '';
                let data = {};

                if (contentType.includes('application/json')) {
                    try {
                        data = await response.json();
                    } catch {
                        data = {};
                    }
                } else {
                    const rawBody = await response.text();
                    const snippet = rawBody ? rawBody.slice(0, 200) : '';
                    throw new Error(`Autofill request failed (${response.status}). ${snippet}`);
                }

                if (!response.ok || data.status >= 400) {
                    throw new Error(data.error || 'Unable to find matching product information.');
                }

                const lookupData = data.data || {};
                const updates = {};
                ['productName', 'sku', 'bullet1', 'bullet2', 'bullet3', 'bullet4', 'bullet5', 'regular_price'].forEach((key) => {
                    const value = lookupData[key];
                    if (value !== undefined && value !== null && value !== '') {
                        updates[key] = String(value);
                    }
                });

                if (Object.keys(updates).length === 0) {
                    throw new Error('No usable product fields were returned for autofill.');
                }

                setProduct({ ...product, ...updates });
                setAutoFillFormState({ ...autoFillFormState, ...updates });
                setAutoFillSearchFormState({
                    sku: lookupData.sku || sku,
                    mfr: lookupData.manufacturer_part_number || mfr,
                });
            })
            .catch((error) => {
                alert(error.message || 'There was an error connecting to the database.');
            })
            .finally(() => {
                setAutoFillLoading(false);
            });
    }
    
    // If there is no product, return select header
    if (Object.keys(product).length === 0) {
        return (
            <Row className="text-center align-items-center">
                <h3 style={{paddingTop: '5px'}}>Select a product to edit</h3>
            </Row>
        )
    }

    return (
        <div>
            {!isNew ?
                <Row className="text-center align-items-center">
                    <h3 style={{paddingTop: '5px'}}>Edit Product</h3>
                </Row>
                : <Row className="text-center align-items-center" style={{
                    backgroundColor: "#a73c21"
                }}>
                    <h3 style={{color: 'white', paddingTop: '5px'}}>Adding New Product</h3>
                </Row>
            }
            <Row>
                <hr/>
                <Form onSubmit={handleProductFormSubmit}>
                    <Row className="mb-3">
                        <Col xs={4} className="text-start">
                            <Form.Label>Autofill SKU</Form.Label>
                            <Form.Control
                                name="sku"
                                value={autoFillSearchFormState.sku}
                                onChange={handleAutofillSearchInputChange}
                                placeholder="Enter SKU"
                            />
                        </Col>
                        <Col xs={4} className="text-start">
                            <Form.Label>Autofill MFR</Form.Label>
                            <Form.Control
                                name="mfr"
                                value={autoFillSearchFormState.mfr}
                                onChange={handleAutofillSearchInputChange}
                                placeholder="Enter manufacturer part #"
                            />
                        </Col>
                        <Col xs={4} className="d-flex align-items-end">
                            <button
                                className="btn btn-primary"
                                style={{
                                    backgroundColor: '#a73c21',
                                    borderColor: '#a73c21',
                                }}
                                type="button"
                                onClick={queryPromoAutofill}
                            >
                                Search and Autofill
                            </button>
                        </Col>
                        {autoFillLoading ? (
                            <Col xs={12} className="text-start mt-2">
                                <p>Loading results...</p>
                            </Col>
                        ) : null}
                        <Col xs={12}>
                            <hr />
                        </Col>
                    </Row>
                    <TextInput inputName="productName" inputLabel="Promo Header"
                        //asterisk={true}
                        placeholder={"Large font on promo (name, etc)"}
                        inputValue={product.productName} inputRequired={false} changeFunc={handleProductsChange}
                        autoFillInfo={('productName' in autoFillFormState)
                            ? {'value': autoFillFormState.sku,
                                'fill': () => dataFromAutoFill('productName')
                            }
                            : null
                    }/>
                    <TextInput inputName="sku" inputLabel="SKU/Item #:"
                        //asterisk={true}
                        placeholder={"Item SKU (or SKUs)"}
                        inputValue={product.sku} inputRequired={false} changeFunc={handleProductsChange}
                        autoFillInfo={('sku' in autoFillFormState)
                            ? {'value': autoFillFormState.sku,
                                'fill': () => dataFromAutoFill('sku')
                            }
                            : null
                    }/>
                    <TextInput inputName="bullet1" inputLabel="Bullet Point 1:" inputValue={product.bullet1} changeFunc={handleProductsChange}/>
                    <TextInput inputName="bullet2" inputLabel="Bullet Point 2:" inputValue={product.bullet2} changeFunc={handleProductsChange}/>
                    <TextInput inputName="bullet3" inputLabel="Bullet Point 3:" inputValue={product.bullet3} changeFunc={handleProductsChange}/>
                    <TextInput inputName="bullet4" inputLabel="Bullet Point 4:" inputValue={product.bullet4} changeFunc={handleProductsChange}/>
                    <TextInput inputName="bullet5" inputLabel="Bullet Point 5:" inputValue={product.bullet5} changeFunc={handleProductsChange}/>
                    <TextInput inputName="save_circle" inputLabel="Save Circle:" inputValue={product.save_circle} changeFunc={handleProductsChange}/>
                    <TextInput inputName="regular_price" inputLabel="Regular Price:" inputValue={product.regular_price} changeFunc={handleProductsChange} placeholder={"Regular price for item"}/>
                    <TextInput inputName="sale_price" inputLabel="Sale Price:" inputValue={product.sale_price} changeFunc={handleProductsChange} placeholder={"Only printed on Standard and Minimal templates"}/>
                    <TextInput inputName="print_promo_id" inputLabel="Promo ID:" inputValue={product.print_promo_id} changeFunc={handleProductsChange} placeholder={`Leave blank to print "${promoId}"`}/>

                    {/* Image fields */}
                    <hr/>
                    <h5 className="mt-3">Product Images</h5>
                    {[1, 2, 3, 4].map(index => (
                        <ImageField 
                        key={index}
                        index={index}
                        product={product}
                        setProduct={setProduct}
                        searchForImage={searchForImage}
                        />
                    ))}
                    <hr/>
                    <div className="d-flex justify-content-start">
                        <button className="btn btn-primary" style={{
                            backgroundColor: "#a73c21",
                            borderColor: "#a73c21"}} type="submit">Save</button>
                    </div>
                </Form>
                {/*<Col xs={3}>

                </Col>
                <h3>${product.name}</h3>
                <p>${product.regular_price}</p>*/}
            </Row>
        </div>
    )

}

export default PromoProductForm;